import React from "react";

const Close: React.FC<any> = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    viewBox="0 0 512 512"
  >
    <line
      x1="368"
      y1="368"
      x2="144"
      y2="144"
      style={{
        fill: "none",
        stroke: props.color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
    <line
      x1="368"
      y1="144"
      x2="144"
      y2="368"
      style={{
        fill: "none",
        stroke: props.color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
  </svg>
);

export default Close;
